export default "__VITE_ASSET__DxkrqNhd__"